
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Badge from 'vux/src/components/badge/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import backend from '@/modules/Backend'
import map from 'lodash/map'
import format from 'date-fns/format'

export default {
  directives: {
    TransferDom
  },
  components: {
    Group,
    Cell,
    Badge,
    XHeader,
    Loading
  },
  data () {
    return {
      courseInstances: []
    }
  },
  methods: {
    async loadSchedule () {
      let schedule = await backend.fetchDaySchedules()
      let courseInstances = await backend.fetchDayCourseInstances(
        map(schedule[0].cells, 'course_instance_id'))
      this.courseInstances = courseInstances.map(item => {
        item.homework = item.statistic.homework_total - item.statistic.homework_done
        item.participation = item.statistic.participation_in_week[schedule[0].wday]
        item.comments = (item.statistic.comments !== '-') ? item.statistic.comments : ''
        return item
      })
    }
  },
  async mounted () {
    this.$vux.loading.show()
    await this.loadSchedule()
    this.$vux.loading.hide()
    backend.updateFeedback('me', format(new Date(), 'YYYY-MM-DD'))
  }
}



// WEBPACK FOOTER //
// ./src/components/Day.vue